export default __webpack_public_path__ + "static/media/semanticuireact.0afc5c81.png";